import styled, { css } from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isDisabled?: boolean
	isFocused?: boolean
	hasError?: boolean
	checkedType: 'no' | 'partial' | 'yes'
}

const padding = 16

export const Checkbox = styled(ButtonPlain)<Props>`
	display: flex;
	position: relative;
	column-gap: 8px;
	padding: ${padding}px 0;

	&:before {
		content: '';
		display: block;
		cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
		border: 2px solid ${({ checkedType, hasError, theme }) => {
			if (hasError) return theme.color.danger
			switch (checkedType) {
				case 'no':
					return theme.color.primary
				case 'partial':
					return theme.color.primary
				case 'yes':
					return theme.color.primary
			}
		}};
		border-radius: 2px;
		width: 22px;
		height: 22px;
		background-color: ${({ checkedType, isDisabled }) => {
			switch (checkedType) {
				case 'no':
					return isDisabled ? helpers.color.input.toggleBackgroundDisabled : helpers.color.cardBackground
				case 'partial':
					return isDisabled ? helpers.color.input.toggleBackgroundDisabled : helpers.color.primary
				case 'yes':
					return isDisabled ? helpers.color.input.toggleBackgroundDisabled : helpers.color.primary
			}
		}};
		outline: 0;
		flex-shrink: 0;

		transition:
			box-shadow 0.15s ease-in-out,
			border-color 0.15s ease-in-out,
			background-color 0.15s ease-in-out;
	}

	&:after {
		content: '';
		position: absolute;
		border: solid white;
		top: ${padding + 7}px;
		left: 8px;
		width: 6px;
		height: 6px;
		border-width: 0 0 0 0;
		transition:
			border-width 0.15s ease-in-out,
			height 0.15s ease-in-out,
			width 0.15s ease-in-out,
			top 0.15s ease-in-out,
			left 0.15s ease-in-out,
			transform 0.15s ease-in-out;

		${({ checkedType }) => {
			switch (checkedType) {
				case 'yes':
					return css`
						height: 14px;
						top: ${padding + 2}px;
						left: 8px;
						width: 6px;
						border-width: 0 2px 2px 0;
						transform: rotate(37deg);
					`
				case 'partial':
					return css`
						top: ${padding + 9}px;
						left: 6px;
						width: 10px;
						height: 0;
						border-width: 0 0 2px 0;
					`
			}
		}}
	}
`
